define(function(e,r,t){function n(e){return{get:function(r){var t=e.defer(),n=sessionStorage.getItem(r);return null==n?t.reject():t.resolve(JSON.parse(n)),t.promise},set:function(r,t){var n=e.defer(),o="object"==typeof t?JSON.stringify(t):t;return sessionStorage.setItem(r,o),n.resolve(),n.promise},purge:function(e){sessionStorage.removeItem(e)}}}n.$inject=["$q"],r.CacheService=n});


// WEBPACK FOOTER //
// ./src/feature-hdfc-common-utility/scripts/CacheService.js